import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventRequestsThunk, updateEventRequestThunk } from "../../AcademicCalendar/redux/createEventRequestThunk";
import AllFeatureDataTable from "../../../GuiComponents/AllFeatureDataTable.table";
import { useNavigate } from "react-router-dom";
import "./events-responsive.css";

const EventRequestTab = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { data = [], loading, error } = useSelector((state) => state.eventRequest || {});

    useEffect(() => {
        dispatch(fetchEventRequestsThunk());
    }, [dispatch]);

    const handleView = (activities = []) => {
        alert(
            "Activities:\n\n" +
            activities
                .map(
                    (act, idx) =>
                       `${idx + 1}. ${act.activity_name} - ${act.activity_desc || act.description || act.time || ""}`

                )
                .join("\n")
        );
    };

    const handleApprove = (eventData) => {
        navigate("/addEvent", { state: { event: eventData } });
    };


    const handleReject = async (eventId) => {
        const eventToReject = data.find(event => event.id === eventId);
        if (!eventToReject) return alert("Event not found");

        const confirmReject = window.confirm("Are you sure you want to reject this event?");
        if (!confirmReject) return;

        const rejectedPayload = {
            event_name: eventToReject.event_name,
            event_date: eventToReject.event_date,
            activities: eventToReject.activities,
            status: 0
        };

        try {
            await dispatch(updateEventRequestThunk({ id: eventId, data: rejectedPayload }));
            alert("Event rejected successfully!");
            dispatch(fetchEventRequestsThunk()); // Refresh table
        } catch (err) {
            alert("Failed to reject event.");
            console.error(err);
        }
    };


    const processedData = useMemo(() => {
        return data.map((event, index) => ({
            ...event,
            sno: index + 1,
            view: (
                <button
                    className="btn btn-sm btn-outline-info"
                    onClick={() => handleView(event.activities)}
                >
                    View
                </button>
            ),
            action: (
                <div className="d-flex gap-2">
                    <button className="btn btn-sm btn-success" onClick={() => handleApprove(event)} disabled={event.status === 1}>
                        Approve
                    </button>
                    <button className="btn btn-sm btn-warning" onClick={() => handleReject(event.id)} disabled={event.status === 1}>
                        Reject
                    </button>
                </div>
            ),
            statusText:
                event.status === 0 ? (
                    <span className="badge bg-warning text-dark">Pending</span>
                ) : (
                    <span className="badge bg-success">Approved</span>
                ),
        }));
    }, [data]);

    const columns = useMemo(
        () => [
            { Header: "#", accessor: "sno" },
            { Header: "Event Name", accessor: "event_name" },
            { Header: "View Activities", accessor: "view" },
            { Header: "Actions", accessor: "action" },
            { Header: "Status", accessor: "statusText" },
        ],
        []
    );

    return (
        <div className="container-fluid event-request-wrapper px-5">
            {/* <h2 className="mb-4">Event Requests</h2> */}
            {loading && <p>Loading...</p>}
            {error && <p className="text-danger">{error.message || "An unknown error occurred."}</p>} {/* MODIFIED LINE */}

            {processedData.length > 0 ? (
                <AllFeatureDataTable columns={columns} data={processedData} />
            ) : (
                <p>No Event Requests Found</p>
            )}
        </div>
    );
};

export default EventRequestTab; 